export const ROUTES = {
  HOME: '/',
  TARGET: '/target',
  DAMAGE: '/damage',
  HEALTH: '/health',
  SIMULATIONS: '/simulations',
  SEQUENCE_SIMULATOR: '/sequence-simulator',
  RANKINGS: '/rankings',
  PDF: '/pdf',
  ABOUT: '/about',
  IMPORT: '/import',
  LISTS_ANALYSIS: '/lists-analysis',
  SETTINGS: '/settings',
};

export const HASHES = {
  DRAWER: '#menu',
  MODIFIERS: '#modifiers',
  ARMY: '#army',
  SIM_CONFIG: '#num-sims',
  SIM_INFO: '#info',
};
